export default "__VITE_ASSET__BZM_chd___"